/*
 * Actions types
 */
export enum AnonymTypes {
  ANONYM_RESQUEST = '@anonym/ANONYM_RESQUEST',
  ANONYM_SUCCESS = '@anonym/ANONYM_SUCCESS',
  ANONYM_FAILURE = '@anonym/ANONYM_FAILURE',
  POST_ANONYM_RESQUEST = '@anonym/POST_ANONYM_RESQUEST',
  POST_ANONYM_SUCCESS = '@anonym/POST_ANONYM_SUCCESS',
  POST_ANONYM_FAILURE = '@anonym/POST_ANONYM_FAILURE',
  DELETE_ANONYM_RESQUEST = '@anonym/DELETE_ANONYM_RESQUEST',
  DELETE_ANONYM_SUCCESS = '@anonym/DELETE_ANONYM_SUCCESS',
  DELETE_ANONYM_FAILURE = '@anonym/DELETE_ANONYM_FAILURE',
}

export interface User {
  emails: [];
  identification_key: string;
  links: any;
}

/*
 * State Type
 */
export interface AnonymState {
  readonly data: any;
  readonly loading: boolean;
  readonly error: boolean;
}
